import React from 'react';

function UserLocationMarker(props) {
		return (
				<div className="c-locator__marker c-locator__marker--green" aria-label="Current location">
						<div className="c-locator__marker-pin"></div>
				</div>
		);
}

export default UserLocationMarker;
